const startCase = require('lodash/startCase');

const templateUrl = require('./remove-item-dialog.html');

class RemoveItemController {
  static get $inject() {
    return [
      '$state',
      '$translate',
      'itemService',
      'dialogService',
      'toastService',
      'subscriptionOrchestrator',
      'ogProductLocaleFilter'
    ];
  }

  constructor($state, $translate, itemService, dialogService, toastService, subscriptionOrchestrator, ogProductLocaleFilter) {
    this.$state = $state;
    this.$translate = $translate;
    this.itemService = itemService;
    this.dialogService = dialogService;
    this.toastService = toastService;
    this.subscriptionOrchestrator = subscriptionOrchestrator;
    this.ogProductLocaleFilter = ogProductLocaleFilter;
    this.getFollowingOrderDate = this.getFollowingOrderDate.bind(this);
  }

  getFollowingOrderDate({ subscription } = {}) {
    if (subscription) {
      return this.subscriptionOrchestrator.getNthNextOrderDate(subscription, 2);
    }
    return null;
  }

  removeItem(item) {
    const prodName = startCase(this.ogProductLocaleFilter(item.product, 'name'));
    const dialog = this.dialogService.open({
      templateUrl: templateUrl,
      confirmText: this.$translate.instant('MODAL_REMOVE_ITEM_SAVE'),
      resolve: {
        productName: () => item.product && this.ogProductLocaleFilter(item.product, 'name'),
        followingOrderDate: () => this.getFollowingOrderDate(item)
      },
      onSuccess: () => this.itemService.removeItem(item)
        .then(() => {
          const successMessage = item.subscription
            ? 'TOAST_REMOVE_SUBSCRIPTION_ITEM_SUCCESS'
            : 'TOAST_REMOVE_ONE_TIME_ITEM_SUCCESS';
          this.toastService.translate.success(successMessage, { productNameCapitalizeFirst: prodName });
        })
        .then(() => {
          this.$state.reload();
        })
        .catch(() => {
          const errorMessage = item.subscription
            ? 'TOAST_REMOVE_SUBSCRIPTION_ITEM_DANGER'
            : 'TOAST_REMOVE_ONE_TIME_ITEM_DANGER';
          this.toastService.translate.danger(errorMessage, { productNameCapitalizeFirst: prodName });
        }),
      windowTopClass: 'og-remove-item-modal',
      ariaLabelledBy: 'og-remove-item-modal-title',
      ariaDescribedBy: 'og-remove-item-modal-description'
    });

    return dialog.result;
  }
}

module.exports = RemoveItemController;
